import PageHeading from "../../../components/desktop/PageHeading";
import { toast } from "react-toastify";
import React, {
    useState,
    useEffect,
} from "react";
import { FaRegEdit } from "react-icons/fa";
import "./Departmentmaster.css";
import { useAuthStore } from "../../../store/authStore";
import back from "../../../assets/back.png";
import { useLoaderStore } from "../../../store/loaderStore";
import { api } from "../../../utils/api";

export default function Departmentmaster() {
    const { showLoader, hideLoader } = useLoaderStore();
    const [departments, setDepartments] = useState([]);
    const [status, setStatus] = useState(true);

    const { user, isAuthenticated } = useAuthStore();

    const companyId = user?.company_id;

    const [showForm, setShowForm] = useState(false);

    const [editId, setEditId] = useState(null);

    const fetchDepartments = async () => {
    try {
        showLoader("master");

        const response = await api.get(
            `/department/list/${companyId}`
        );

        const result = await response.json();

        setDepartments(result);

        toast.success("Departments loaded successfully");

    } catch (error) {
        console.error(error);

        toast.error(
            error.message || "Failed to load departments"
        );
    } finally {
        hideLoader();
    }
};

    useEffect(() => {
        if (companyId && isAuthenticated) {
            fetchDepartments();
        }
    }, [companyId, isAuthenticated]);

    const [departmentName, setDepartmentName] =
        useState("");

    const toggleStatus = async (item) => {
        try {
            showLoader("master");
            const response = await api.put(`/department/update/${item.id}`, {
              company_id: item.company_id,
              department_name: item.department_name,
              isactive: item.isactive === 1 ? 0 : 1
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(
                    result.message || "Failed to update status"
                );

            }

            fetchDepartments();
        } catch (error) {
            console.error(error);
        } finally {
            hideLoader();
        }
    };

    const handleEdit = (item) => {
        setEditId(item.id);

        setDepartmentName(item.department_name);
        setStatus(item.isactive === 1);

        setShowForm(true);
    };

    const handleSave = async () => {
        if (!departmentName.trim()) {
            toast.warning("Department Name is required");
            return;
        }

        try {
            showLoader("master");
            let response;

            if (editId) {
                response = await api.put(`/department/update/${editId}`, {
                  company_id: companyId,
                  department_name: departmentName,
                  isactive: status ? 1 : 0
                });
            } else {
                response = await api.post(`/department/add`, {
                  company_id: companyId,
                  department_name: departmentName,
                  isactive: 1
                });
            }

            const result = await response.json();

            if (!response.ok) {
                throw new Error(
                    result.message || "Operation failed"
                );
            }

            await fetchDepartments();

            setDepartmentName("");
            setEditId(null);
            setShowForm(false);
        } catch (error) {
            console.error(error);
            alert(error.message);
        } finally {
            hideLoader();
        }
    };

    const handleCancel = () => {
        setDepartmentName("");
        setStatus(true);
        setEditId(null);
        setShowForm(false);
    };

    return (
        <div className="department-master-container">
      <PageHeading>Department Master</PageHeading>
            {!showForm ? (
                <>
                    <div className="department-master-top">
                        <button
                            className="add-department-btn"
                            onClick={() => {
                                setDepartmentName("");
                                setStatus(true);
                                setEditId(null);
                                setShowForm(true);
                            }}
                        >
                            + Add Department
                        </button>
                    </div>

                    <div className="department-table-wrapper">
                        <table className="department-table">
                            <thead>
                                <tr>
                                    <th className="serial-col">Sr.no</th>
                                    <th>Department Name</th>
                                    <th className="status-col">Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {departments.map((item, index) => (
                                    <tr key={item.id}>
                                        <td className="serial-col">
                                            {index + 1}
                                        </td>

                                        <td>{item.department_name}</td>

                                        <td className="status-col">
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={item.isactive === 1}
                                                    onChange={() => toggleStatus(item)}
                                                />
                                                <span className="slider"></span>
                                            </label>

                                        </td>

                                        <td className="action-cell">
                                            <FaRegEdit
                                                className="edit-icon"
                                                onClick={() => handleEdit(item)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <div className="department-form-container">

                    <div className="department-form-header">
                        <img
                            src={back}
                            alt="Back"
                            className="back-btn-img"
                            onClick={handleCancel}
                        />

                        <h3>
                            {editId ? "Edit Department" : "Add Department"}
                        </h3>
                    </div>

                    <div className="department-form">
                        <div className="department-name-group">
                            <label>
                                Department Name <span>*</span>
                            </label>

                            <input
                                type="text"
                                value={departmentName}
                                onChange={(e) =>
                                    setDepartmentName(e.target.value)
                                }
                                placeholder="Enter Department Name"
                            />
                        </div>

                        {editId && (
                            <div className="department-status-group">
                                <label>Status</label>

                                <select
                                    value={status ? "Active" : "Inactive"}
                                    onChange={(e) =>
                                        setStatus(e.target.value === "Active")
                                    }
                                >
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        )}
                    </div>

                    <div className="form-actions">
                        <button
                            className="cancel-btn"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>

                        <button
                            className="save-btn"
                            onClick={handleSave}
                        >
                            {editId ? "Update" : "Save"}
                        </button>
                    </div>

                </div>
            )}
        </div>
    );
}